import React, { useEffect, useRef } from 'react';

interface AdLeaderboardSmallProps {
  className?: string;
}

const AdLeaderboardSmall: React.FC<AdLeaderboardSmallProps> = ({ className }) => {
  const adContainerRef = useRef<HTMLDivElement>(null);
  const isScriptInjected = useRef(false);

  useEffect(() => {
    if (isScriptInjected.current || !adContainerRef.current) return;
    
    // Create and inject the options script
    const optionsScript = document.createElement('script');
    optionsScript.type = 'text/javascript';
    optionsScript.textContent = `
      atOptions = {
        'key' : '4f5e379c17a044ce7434cb3068b0b4ec',
        'format' : 'iframe',
        'height' : 60,
        'width' : 468,
        'params' : {}
      };
    `;
    
    // Create and inject the invoke script
    const invokeScript = document.createElement('script');
    invokeScript.type = 'text/javascript';
    invokeScript.src = '//resideour.com/4f5e379c17a044ce7434cb3068b0b4ec/invoke.js';
    
    // Append all elements to the container
    adContainerRef.current.appendChild(optionsScript);
    adContainerRef.current.appendChild(invokeScript);
    
    isScriptInjected.current = true;
    
    // Cleanup function
    return () => {
      if (adContainerRef.current) {
        adContainerRef.current.innerHTML = '';
      }
      isScriptInjected.current = false;
    };
  }, []);

  return (
    <div 
      ref={adContainerRef} 
      className={`ad-leaderboard-small w-full overflow-hidden ${className || ''}`}
      style={{ height: '60px', maxWidth: '468px', margin: '0 auto' }}
    />
  );
};

export default AdLeaderboardSmall;